import { LocationSpecificSurveyInput } from './';
export interface ScoreDto {
  scoreDto: {
    surveyDto?: LocationSpecificSurveyInput;
    updateScore?: number;
    adminEditScore?: number;
    directServiceScore?: number;
    refusedQuestionScore?: number;
    localStaffScore?: number;
  };
}
